import moment from "moment/moment";

export function setFormBankStatement(state, data) {
    state.formBankStatement = {
        ...state.formBankStatement,
        ...data
    };
}

export function setFormBankConciliation(state, data) {
    state.formBankConciliation = {
        ...state.formBankConciliation,
        ...data
    };
}

export function setAccounts(state, data) {
    state.accounts = data;
}

export function setDataBankConciliation(state, data) {
    const documentTransactions = data.documentTransactions;
    const newDocumentTransactions = documentTransactions.map(item => ({
        ...item,
        cod_contact_transaction: item.contact.identification
    }));
    state.dataBankConciliation = {
        ...data,
        documentTransactions: newDocumentTransactions
    };
}

export function setFormBankStatementResponse(state, data) {
    state.formBankStatementResponse = data;
}

export function setFormBankStatementLoading(state, value) {
    state.formBankStatementLoading = value;
}

export function setDataBankConciliationLoading(state, value) {
    state.dataBankConciliationLoading = value;
}

export function setBankConciliationOperTransactions(state, data) {
    state.bankConciliationOperTransactions = {
        ...state.bankConciliationOperTransactions,
        ...data
    };
}

export function setBankConciliationTransactionsDetail(state, value) {
    state.bankConciliationTransactionsDetail = value;
}

export function setBankConciliationStatus(state, value) {
    state.bankConciliationStatus = value;
}

export function setDataBankConciliationTransactions(state, data) {
    state.dataBankConciliationTransactions = data;
}

export function setGenerateBankConciliationResponse(state, data) {
    state.generateBankConciliationResponse = data;
}

export function orderByItemBankDocumentTransactions(state, params) {
    const {
        items = [],
        keyTable,
        prioritySelected = false,
        totalValue = 0
    } = params;

    const item = items[0];

    console.log("state.dataBankConciliation :>> ", state.dataBankConciliation);

    // Reset data
    if (keyTable === "bankConcilOper") {
        state.dataBankConciliation.bankConcilOper = state.dataBankConciliation.bankConcilOper.map(
            item => ({
                ...item,
                isSort: false,
                isEqualValue: false
            })
        );
    } else {
        state.dataBankConciliation.documentTransactions = state.dataBankConciliation.documentTransactions.map(
            item => ({
                ...item,
                isSort: false,
                isEqualValue: false
            })
        );
    }

    const tableUpdateKey =
        keyTable === "bankConcilOper"
            ? "documentTransactions"
            : "bankConcilOper";

    const data = state.dataBankConciliation[tableUpdateKey];
    let keysPropObj = {
        date: "oper_date",
        type: "tran_type",
        value: "oper_value",
        cod_contact: "cod_contact"
    };
    let keysPropArr = {
        date: "document_date",
        type: "transactions_type",
        value: "operation_value",
        cod_contact: "cod_contact_transaction"
    };

    if (keyTable === "documentTransactions") {
        keysPropObj = {
            date: "document_date",
            type: "transactions_type",
            value: "operation_value",
            cod_contact: "cod_contact"
        };
        keysPropArr = {
            date: "oper_date",
            type: "tran_type",
            value: "oper_value",
            cod_contact: "cod_contact"
        };
    }

    const dataSortVal = data.map(d => {
        let isSort = false;
        let isEqualValue = d[keysPropArr.value] == totalValue;

        if (d[keysPropArr.type] === item[keysPropObj.type]) {
            isSort = true;
        }

        if (d[keysPropArr.cod_contact] === item[keysPropObj.cod_contact]) {
            isSort = true;
        }

        return {
            ...d,
            isSort,
            isEqualValue: isSort && isEqualValue
        };
    });

    const data1 = dataSortVal.filter(item => item.isSort);
    const data2 = dataSortVal.filter(item => !item.isSort);

    data1.sort((a, b) => {
        const diffValorA = Math.abs(
            a[keysPropArr.value] - item[keysPropObj.value]
        );
        const diffValorB = Math.abs(
            b[keysPropArr.value] - item[keysPropObj.value]
        );

        const diffDateA = Math.abs(
            moment(a[keysPropArr.date])
                .startOf("day")
                .diff(moment(item[keysPropObj.date]).startOf("day"))
        );
        const diffDateB = Math.abs(
            moment(b[keysPropArr.date])
                .startOf("day")
                .diff(moment(item[keysPropObj.date]).startOf("day"))
        );

        if (diffValorA !== diffValorB) {
            return diffValorA - diffValorB;
        }

        if (item.cod_contact) {
            const isCodContactMatchA =
                a[keysPropArr.cod_contact] === item[keysPropObj.cod_contact];
            const isCodContactMatchB =
                b[keysPropArr.cod_contact] === item[keysPropObj.cod_contact];

            if (
                isCodContactMatchA &&
                a[keysPropArr.value] === item[keysPropObj.value]
            ) {
                return 0;
            } else if (isCodContactMatchA) {
                return -1;
            } else if (isCodContactMatchB) {
                return 1;
            }
        }

        return diffDateA - diffDateB;
    });

    data2.sort((a, b) => {
        return a[keysPropArr.value] - b[keysPropArr.value];
    });

    data2.sort((a, b) => {
        if (a[keysPropArr.type] !== b[keysPropArr.type]) {
            if (a[keysPropArr.type] === item[keysPropObj.type]) return -1;
            if (b[keysPropArr.type] === item[keysPropObj.type]) return 1;

            return a[keysPropArr.type].localeCompare(b[keysPropArr.type]);
        }

        const diffA = Math.abs(a[keysPropArr.value] - totalValue);
        const diffB = Math.abs(b[keysPropArr.value] - totalValue);

        if (diffA < diffB) return -1;
        if (diffA > diffB) return 1;

        return 0;
    });

    setDataBankConciliationSelectedPriority(state, {
        data: { [tableUpdateKey]: data1.concat(data2) },
        prioritySelected
    });
}

export function setDataBankConciliationSelectedPriority(state, params) {
    const { data, prioritySelected } = params;

    if (prioritySelected) {
        const dataReorder = {
            ...state.dataBankConciliation,
            ...data
        };

        const {
            informationExtract,
            accountingInformation
        } = state.bankConciliationOperTransactions;

        const informationExtractIds = informationExtract.map(item => item.id);
        const accountingInformationIds = accountingInformation.map(
            item => item.id
        );

        const bankConcilOperSelected = dataReorder.bankConcilOper
            .filter(item => informationExtractIds.includes(item.id))
            .slice();
        const documentTransactionsSelected = dataReorder.documentTransactions.filter(
            item => accountingInformationIds.includes(item.id)
        );

        const bankConcilOperNotSelected = dataReorder.bankConcilOper.filter(
            item => !informationExtractIds.includes(item.id)
        );
        const documentTransactionsNotSelected = dataReorder.documentTransactions.filter(
            item => !accountingInformationIds.includes(item.id)
        );

        bankConcilOperSelected.sort((a, b) => a.id - b.id);
        documentTransactionsSelected.sort((a, b) => a.id - b.id);

        const bankConcilOper = [
            ...bankConcilOperSelected,
            ...bankConcilOperNotSelected
        ];

        const documentTransactions = [
            ...documentTransactionsSelected,
            ...documentTransactionsNotSelected
        ];

        const bankConcilOperUnique = bankConcilOper.filter(
            (item, index, self) =>
                index === self.findIndex(obj => obj.id === item.id)
        );

        const documentTransactionsUnique = documentTransactions.filter(
            (item, index, self) =>
                index === self.findIndex(obj => obj.id === item.id)
        );

        state.dataBankConciliation = {
            bankConcilOper: bankConcilOperUnique,
            documentTransactions: documentTransactionsUnique
        };
    } else {
        const dataReorder = {
            ...state.dataBankConciliation,
            ...data
        };

        state.dataBankConciliation = dataReorder;
    }
}

export function setBankReconciliationReport(state, data) {
    state.bankReconciliationReport = data;
}

export function setBankReconciliationReportResponse(state, data) {
    state.bankReconciliationReportResponse = data;
}

export function setAuxiliaryAccounts(state, data) {
    state.auxiliary_accounts = data;
}

export function setDataVoucherTransaction(state, data) {
    if (data.debit_credit === "C") {
        state.voucherPayload.total_credit = data.value;
    } else {
        state.voucherPayload.total_debit = data.value;
    }
    state.voucherPayload.document_transaction = data;
}

export function setConsecutive(state, consecutive) {
    let consecutive_number = consecutive.consecutive_number + 1;
    state.voucherPayload.no_doc = consecutive_number.toString();
    state.voucherPayload.prefix = consecutive.prefix;
}

export function updateVoucherPayload(state, document_transaction) {
    let transaction = document_transaction;
    transaction.id_document_transactions = document_transaction.id;
    transaction.value = document_transaction.operation_value;
    transaction.debit_credit = document_transaction.transactions_type;
    transaction.observation = document_transaction.observations
        ? document_transaction.observations
        : document_transaction.observation
        ? document_transaction.observation
        : state.voucherPayload.document_transaction.observation;

    state.voucherPayload.document_id = document_transaction.document_id;
    state.voucherPayload.prefix = document_transaction.document
        ? document_transaction.document.prefix
        : null;
    state.voucherPayload.consecutive = document_transaction.document
        ? document_transaction.document.consecutive
        : null;
    state.voucherPayload.document_transactions.push(transaction);
}

export function setFinalizeVoucher(state, data) {
    state.show_pdf = true;
    state.file_name = data.accounting_link;
}
export function clearParamsModalTransaction(state, data) {
    state.show_pdf = false;
    state.file_name = "";
    state.voucherPayload = {
        branchoffice_id: null,
        voucherType_id: null,
        no_doc: null,
        prefix: null,
        date: "",
        contact_id: null,
        city_id: null,
        document_id: null,
        user_id: null,
        document_transaction: {
            id: null,
            account_id: null,
            observation: "",
            contact_id: 0,
            no_doc: null,
            value: 0,
            base_value: 0,
            order: 1,
            projects_column_visible: 0,
            contact_column_visible: true,
            cost_center_column_visible: false,
            base_value_column_visible: false,
            manage_document: false,
            validation_no_doc: null,
            account_code: "",
            account_name: "",
            tax_id: null,
            payment_column_visible: false,
            manage_bank_document: false,
            commissionable_concept: false,
            debit_credit: null,
            id_document_transactions: null
        },
        document_transactions: [],
        total_debit: null,
        total_credit: null,
        ids_conciliation: []
    };
}

export function setIdsConciliation(state, data) {
    state.voucherPayload.ids_conciliation = data;
}

export function setModalloading(state, data) {
    state.voucherPayload.modal_loading = data;
}
export function setConsignedData(state, data) {
    state.payload.update_document_payments_methods.push(data);
}



// WEBPACK FOOTER //
// ./src/modules/incorporate-bank-statement/mutations.js